// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width: 991px) {\n.dropdown-content[data-v-5f3506f4] {\n    max-width: 6em;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n}\n", ""]);
// Exports
module.exports = exports;
